import * as tslib_1 from "tslib";
import { SwitchField } from './switch_field';
var CheckBox = /** @class */ (function (_super) {
    tslib_1.__extends(CheckBox, _super);
    function CheckBox(param) {
        return _super.call(this, param) || this;
    }
    CheckBox.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "CheckBox" });
    };
    CheckBox.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return CheckBox;
}(SwitchField));
export { CheckBox };
//# sourceMappingURL=check_box.js.map